module.exports = {"140213050":"永泰街道","140213051":"古城街道","140213052":"新旺街道","140213053":"迎宾街道","140213054":"振华街道","140213055":"清远街道","140213056":"武定街道","140213057":"御河街道","140213058":"开源街道","140213059":"大庆路街道","140213060":"马军营街道","140213061":"卧虎湾街道","140213062":"新华街道","140213063":"鹿苑街道","140213064":"白登山街道","140213065":"文瀛湖街道","140213066":"水泊寺街道","140213067":"小南头街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140213.json
// module id = 361
// module chunks = 0